import React from 'react';
import IForm from '../../../types/IForm';
import { useSonTranslation } from '../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../_lib/Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';

type ConnectedUsersDeleteFormProps = {
  onSuccess: () => void;
  form: IForm;
};

export function ConnectedUsersDeleteForm({ form, onSuccess }: ConnectedUsersDeleteFormProps) {
  const { t } = useSonTranslation('ConnectedUsers');

  return (
    <AcceptDeclineForm
      form={form as any}
      onSuccess={onSuccess}
      headline={t('deleteForm.question')}
      messageSuccess={t('deleteForm.status.success')}
      messageSending={t('deleteForm.status.sending')}
      messageFail={t('deleteForm.status.fail')}
    />
  );
}
